import { Component, OnInit } from "@angular/core";
import { FileUploader, FileUploaderOptions } from "ng2-file-upload"; //FileSelectDirective,
import { HttpEvent, HttpEventType } from "@angular/common/http";

// PROVIDER
import { BasicProvider } from "../providers/basic/basic";
import { UserProvider } from "../providers/user/user";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  options;
  uploader: FileUploader;
  url = "";
  allowedMimeType = [];
  mobHeight: any;
  mobWidth: any;
  file;
  uploadInProgress = false;
  uploadProgress = 0;
  hasValue = false;
  fileUploadType;
  imgPreview;
  constructor(public bp: BasicProvider, public up: UserProvider) {
    this.mobHeight = window.screen.height;
    this.mobWidth = window.screen.width;

    if (this.bp.between(this.mobWidth, 320, 991)) {
      //console.log('Menu hide');
      this.bp.menu_type = "menu_show";
      this.bp.cantainer_class = "remove_sidebar1"; //remove_sidebar1
      this.bp.side_class = "sidebarcolleps"; //sidebarcolleps
      this.bp.logohide_class = "divHide"; //divHide
      this.bp.divhide_class = "divHide"; //divHide
      this.bp.menuhide_class = "menuTextHide"; //menuTextHide
    }

    this.allowedMimeType = [
      "image/png",
      "image/gif",
      "image/jpg",
      "image/jpeg",
    ];
    this.url = this.bp.httpUrl + "users/update_user_photo_files";
    this.uploader = new FileUploader({
      url: this.url,
      headers: this.options,
      itemAlias: "image",
      allowedMimeType: this.allowedMimeType,
    });

    var uo: FileUploaderOptions = {};
    uo.headers = [{ name: "sid", value: this.up.sid }];
    this.uploader.setOptions(uo);
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (file) => {
      //let file_string = file.target.file[0];
      file.withCredentials = false;
      this.uploader.uploadAll();

      /*console.log(file.file.type);
      let file_type = file.file.type;
      if(file_type =='image/gif' || file_type=='image/jpeg' || file_type=='image/jpg' || file_type=='image/png') {
        file.withCredentials = false;
        this.uploader.uploadAll();
      } else {
        this.bp.show_toast('Error','Only image is allowed.');
        return false;
      } */
    };

    this.uploader.onCompleteItem = (
      item: any,
      success: any,
      status: any,
      headers: any
    ) => {
      let result = JSON.parse(success);
      this.up.profile_image = result.data.image_name;
      this.up.updateProfileImage(this.up.profile_image);
      this.bp.show_toast("Success", result.message);
    };

    this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
      this.bp.show_toast("Error", "Only jpeg, png, gif images are allowed.");
    };
  }

  logout() {
    this.up.logout();
  }

  manageMenu(menu_type) {
    if (menu_type == "menu_hide") {
      this.bp.menu_type = "menu_show";
      this.bp.cantainer_class = "remove_sidebar1"; //remove_sidebar1
      this.bp.side_class = "sidebarcolleps"; //sidebarcolleps
      this.bp.logohide_class = "divHide"; //divHide
      this.bp.divhide_class = "divHide"; //divHide
      this.bp.menuhide_class = "menuTextHide"; //menuTextHide
    } else {
      this.bp.menu_type = "menu_hide";
      this.bp.cantainer_class = ""; //remove_sidebar1
      this.bp.side_class = ""; //sidebarcolleps
      this.bp.logohide_class = ""; //divHide
      this.bp.divhide_class = ""; //divHide
      this.bp.menuhide_class = ""; //menuTextHide
    }
  }

  onchangeFile(event) {
    let allowFileType = ["jpg", "png", "jpeg"];
    let selectedFileType = event.target.files.length
      ? event.target.files[0].name.split(".").pop().toLowerCase()
      : "";
    if (!selectedFileType) return;

    if (!allowFileType.includes(selectedFileType)) {
      this.bp.show_toast(
        "Error",
        "Please select correct file of allow format. Allowled format are jpg, png, jpeg"
      );
      return;
    }

    let data = { location: "users", type: "IMAGE" };
    let api = `warehouse/upload_files`;
    const [file] = event.target.files;
    this.file = file;
    this.bp.hitApi(api, "GET", data, true, true).subscribe((success) => {
      this.hasValue = true;
      if (success.type == true) {
        this.bp.upload(success.data[0].url, file, null, true)
          .subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this.uploadInProgress = true;
                break;
              case HttpEventType.UploadProgress:
                this.uploadProgress = Math.round(
                  (100 * event.loaded) / event.total
                );
                break;
              case HttpEventType.Response:
                this.resetUploadProgress();
                this.file = undefined;
                this.hasValue = true;
                let profilePic = success.data[0].location;
                this.imgPreview = success.data[0].preview;

                api = `users/update_user_photo_files`;
                this.bp
                  .hitApi(api, "POST", { profilePic }, true, true)
                  .subscribe((success) => {
                    if (success.type == true) {
                      this.up.profile_image = profilePic;
                      this.up.updateProfileImage(this.up.profile_image);
                      this.bp.show_toast("Success", success.message);
                    }
                  });
            }
          });
      } else {
        this.bp.show_toast("Error", success.message);
      }
    });
  }

  private resetUploadProgress() {
    this.uploadInProgress = false;
    this.uploadProgress = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts